import { render, staticRenderFns } from "./ClassesUser.vue?vue&type=template&id=34ce2990&scoped=true"
import script from "./ClassesUser.vue?vue&type=script&lang=js"
export * from "./ClassesUser.vue?vue&type=script&lang=js"
import style0 from "./ClassesUser.vue?vue&type=style&index=0&id=34ce2990&prod&scoped=true&lang=css"
import style1 from "./ClassesUser.vue?vue&type=style&index=1&id=34ce2990&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ce2990",
  null
  
)

export default component.exports